import { Routes, Route } from 'react-router-dom';
import AppLayout from '../components/layout/AppLayout';
import DashboardPage from '../features/dashboard/DashboardPage';
import ThreatsPage from '../features/threats/ThreatsPage';
import VulnerabilitiesPage from '../features/vulnerabilities/VulnerabilitiesPage';
import IncidentsPage from '../features/incidents/IncidentsPage';
import IdentityPage from '../features/identity/IdentityPage';
import EndpointPage from '../features/endpoint/EndpointPage';
import EmailPage from '../features/email/EmailPage';
import PentestPage from '../features/pentest/PentestPage';
import AiIntelligencePage from '../features/ai/AiIntelligencePage';
import NetworkDiscoveryPage from '../features/network-discovery/NetworkDiscoveryPage';
import MalwareAnalysisPage from '../features/malware-analysis/MalwareAnalysisPage';
import AutomationPage from '../features/automation/AutomationPage';
import TicketsPage from '../features/tickets/TicketsPage';
import NotificationsPage from '../features/notifications/NotificationsPage';
import AuditLogsPage from '../features/audit-logs/AuditLogsPage';
import SettingsPage from '../features/settings/SettingsPage';
import OrganizationsPage from '../features/organizations/OrganizationsPage';
import AssetsPage from '../features/assets/AssetsPage';
import ThreatIntelPage from '../features/threat-intel/ThreatIntelPage';
import ThreatMonitoringPage from '../features/threat-monitoring/ThreatMonitoringPage';
import VulnManagementPage from '../features/vuln-management/VulnManagementPage';
import SocPage from '../features/soc/SocPage';
import SimLabPage from '../features/simlab/SimLabPage';
import ReportsPage from '../features/reports/ReportsPage';
import CompliancePage from '../features/compliance/CompliancePage';
import PoliciesPage from '../features/policies/PoliciesPage';
import SchedulerPage from '../features/scheduler/SchedulerPage';
import LicensingPage from '../features/licensing/LicensingPage';
import AccountSettingsPage from '../features/account/AccountSettingsPage';
import LoginPage from '../features/auth/LoginPage';
import ProtectedRoute from './ProtectedRoute';
import PortalLayout from '../portal/layout/PortalLayout';
import ProtectedPortalRoute from '../portal/layout/ProtectedPortalRoute';
import PortalLoginPage from '../portal/pages/PortalLoginPage';
import PortalOverviewPage from '../portal/pages/PortalOverviewPage';
import PortalReportsPage from '../portal/pages/PortalReportsPage';
import PortalVulnerabilitiesPage from '../portal/pages/PortalVulnerabilitiesPage';
import PortalNotificationsPage from '../portal/pages/PortalNotificationsPage';
import PortalSupportPage from '../portal/pages/PortalSupportPage';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/threats" element={<ThreatsPage />} />
        <Route path="/vulnerabilities" element={<VulnerabilitiesPage />} />
        <Route path="/incidents" element={<IncidentsPage />} />
        <Route path="/identity" element={<IdentityPage />} />
        <Route path="/endpoint" element={<EndpointPage />} />
        <Route path="/email" element={<EmailPage />} />
        <Route path="/pentest" element={<PentestPage />} />
        <Route path="/ai-intelligence" element={<AiIntelligencePage />} />
        <Route path="/network-discovery" element={<NetworkDiscoveryPage />} />
        <Route path="/malware-analysis" element={<MalwareAnalysisPage />} />
        <Route path="/automation" element={<AutomationPage />} />
        <Route path="/tickets" element={<TicketsPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/audit-logs" element={<AuditLogsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/organizations" element={<OrganizationsPage />} />
        <Route path="/assets" element={<AssetsPage />} />
        <Route path="/threat-intel" element={<ThreatIntelPage />} />
        <Route path="/threat-monitoring" element={<ThreatMonitoringPage />} />
        <Route path="/vulnerability-management" element={<VulnManagementPage />} />
        <Route path="/soc" element={<SocPage />} />
        <Route path="/simlab" element={<SimLabPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/compliance" element={<CompliancePage />} />
        <Route path="/policies" element={<PoliciesPage />} />
        <Route path="/scheduler" element={<SchedulerPage />} />
        <Route path="/licensing" element={<LicensingPage />} />
        <Route path="/account" element={<AccountSettingsPage />} />
        </Route>
      </Route>

      {/* Client Security Portal — separate route tree, own layout & auth gate */}
      <Route path="/portal/login" element={<PortalLoginPage />} />
      <Route
        path="/portal"
        element={
          <ProtectedPortalRoute>
            <PortalLayout />
          </ProtectedPortalRoute>
        }
      >
        <Route index element={<PortalOverviewPage />} />
        <Route path="reports" element={<PortalReportsPage />} />
        <Route path="vulnerabilities" element={<PortalVulnerabilitiesPage />} />
        <Route path="notifications" element={<PortalNotificationsPage />} />
        <Route path="support" element={<PortalSupportPage />} />
      </Route>
    </Routes>
  );
}
